<h2 mat-dialog-title>{{'CONTACT_TABLE.DOWNLOAD_DIALOG.TITLE'| translate}}</h2>
<mat-dialog-content>
  <p>
    {{'CONTACT_TABLE.DOWNLOAD_DIALOG.DESCRIPTION'| translate}}
    <br />
    {{'CONTACT_TABLE.DOWNLOAD_DIALOG.NOTIFICATION'| translate}}
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="secondary" [mat-dialog-close]>{{'COMMON.ACTION_LABELS.CANCEL'| translate}}</button>
  <button mat-raised-button color="primary" (click)="downloadData()">
    {{'CONTACT_TABLE.DOWNLOAD_DIALOG.DOWNLOAD'| translate}}
  </button>
</mat-dialog-actions>
